import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export default function AdminGuard({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center">
          <div className="w-10 h-10 border-2 border-primary-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-sm text-foreground-600">인증 확인 중...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const isAdmin = user.user_metadata?.is_admin === true || user.app_metadata?.is_admin === true;

  if (!isAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center max-w-md px-6">
          <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-5">
            <i className="ri-shield-keyhole-line text-2xl text-red-500" />
          </div>
          <h2 className="text-lg font-bold text-foreground-950 mb-2">접근 권한이 없습니다</h2>
          <p className="text-sm text-foreground-600 mb-6">
            관리자 페이지에 접근할 수 있는 권한이 없습니다.<br />
            관리자 계정으로 로그인해주세요.
          </p>
          <a
            href="/"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium px-5 py-2.5 rounded-md transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-left-line" />
            메인으로 돌아가기
          </a>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}